if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
      this.productWrapper = this.closest('.thb-product-detail');
      if (this.productWrapper) {
        this.productSlider = this.productWrapper.querySelector('.product-images') ? this.productWrapper.querySelector('.product-images') : this.productWrapper.querySelector('.product-quick-images');
        this.thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');
        this.hideVariants = this.productSlider.dataset.hideVariants === 'true';
        this.initCollectionContext();
        this.collectionGender = this.resolveCollectionGender();
      }
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
      this.updateBackInStockTriggers();
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }
      this.updateBackInStockTriggers();
      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.option_keys = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
          this.option_keys.push(fieldset.querySelector('select').name);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
          this.option_keys.push(fieldset.querySelector('input').name);
        }
      });
      this.dataset.options = this.options;
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value="${option}"]`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.productSlider) return;
      if (!this.currentVariant.featured_media) {
        this.setImageSetMedia();
        return;
      }
      let mediaId = `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      let activeMedia = this.productSlider.querySelector(mediaId);

      if (this.thumbnails) {
        this.setActiveMediaSlider(mediaId, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.productSlider);
      } else {
        this.setActiveMedia(activeMedia);
      }

    }
    setActiveMedia(activeMedia) {
      if (!activeMedia) {
        return;
      }

      this.productSlider.querySelectorAll('.product-images__slide, .product-quick-images__slide').forEach((element) => {
        element.classList.remove('is-active');
      });

      this.setImageSetMedia();

      activeMedia.classList.add('is-active');
      this.applyGenderFilter();

      const visibleMedia = activeMedia.classList.contains('is-active') ? activeMedia : this.productSlider.querySelector('.product-images__slide.is-active, .product-quick-images__slide.is-active');
      if (!visibleMedia) {
        return;
      }

      visibleMedia.parentElement.prepend(visibleMedia);

      if (!this.sticky) {
        window.setTimeout(() => {
          if (window.innerWidth > 1068) {
            let header_h = visibleMedia.parentElement.offsetTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')),
              scroll_obj = {
                left: 0,
                behavior: 'instant'
              };

            if (header_h > 0) {
              scroll_obj.top = header_h;
            }
            window.scrollTo(scroll_obj);
          }
          visibleMedia.parentElement.scrollTo({
            left: 0,
            behavior: 'instant'
          });
        });
      }
    }
    setActiveMediaSlider(mediaId, thumbId, productSlider) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);
      if (!activeMedia) {
        return;
      }

      if (flkty && this.hideVariants) {
        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });
        if (this.thumbnails) {
          if (this.thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            this.thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(this.thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });
        }

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        this.setImageSetMedia();

        if (this.thumbnails) {
          let activeThumb = this.thumbnails.querySelector(thumbId);

          if (activeThumb) {
            activeThumb.classList.add('is-active');
            activeThumb.classList.add('is-initial-selected');
          }
        }

        let selectedMediaId = mediaId;
        if (!activeMedia.classList.contains('is-active')) {
          let fallbackMedia = productSlider.querySelector('.product-images__slide.is-active, .product-quick-images__slide.is-active');
          if (fallbackMedia) {
            selectedMediaId = `#${fallbackMedia.id}`;
          }
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(selectedMediaId);

      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      let urlBase = this.dataset.url;
      const collectionHandle = this.resolveCollectionHandle();
      if (collectionHandle) {
        const collectionPath = this.buildCollectionProductUrl(collectionHandle);
        if (collectionPath) {
          urlBase = collectionPath;
        }
      } else if (window.location.pathname.includes('/collections/') && !urlBase.includes('/collections/')) {
        urlBase = window.location.pathname;
      }
      window.history.replaceState({}, '', `${urlBase}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      // PDP modification: keep store availability accordion in sync with variant changes.
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`, `pickup-availability-tab-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          submitButton.classList.add('sold-out');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');
          submitButton.classList.remove('sold-out');

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.textContent = window.theme.variantStrings.addToCart;
          }
        }
      });

      if (!modifyClass) return;
    }

    updateBackInStockTriggers() {
      const backInStockContainers = document.querySelectorAll(`.product-back-in-stock[data-section="${this.dataset.section}"]`);
      if (!backInStockContainers.length) return;

      const showBackInStock = Boolean(this.currentVariant && this.currentVariant.available === false);
      const klaviyoVariantId = this.currentVariant ? `$shopify:::$default:::${this.currentVariant.id}` : '';

      backInStockContainers.forEach((container) => {
        container.dataset.variantId = this.currentVariant ? this.currentVariant.id : '';
        container.dataset.klaviyoVariantId = klaviyoVariantId;

        if (typeof container.updateState === 'function') {
          container.updateState({
            available: showBackInStock,
            variantId: this.currentVariant ? this.currentVariant.id : '',
            klaviyoVariantId: klaviyoVariantId
          });
          return;
        }

        container.hidden = !showBackInStock;
      });
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();


      if (variant_data) {
        let selected_options = false;
        if (this.currentVariant) {
          selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });
        } else {
          let found_option = variant_data.find(option => {
            return option.option1 === this.options[0];
          });
          if (found_option) {
            selected_options = [
              {
                "value": this.options[0],
                "index": "option1"
              },
              {
                "value": found_option.option2,
                "index": "option2"
              }
            ];
          } else {
            return;
          }
        }

        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });

      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    resolveCollectionHandle() {
      if (this.productWrapper && this.productWrapper.dataset.collectionHandle) {
        return this.productWrapper.dataset.collectionHandle;
      }
      let pathMatch = window.location.pathname.match(/\/collections\/([^/]+)/i);
      if (pathMatch && pathMatch[1]) {
        return decodeURIComponent(pathMatch[1]);
      }
      return '';
    }

    normalizeGender(value) {
      if (!value) {
        return '';
      }
      let normalizedValue = this.getImageSetName(value.toString());
      if (!normalizedValue) {
        return '';
      }
      if (normalizedValue === 'w' || normalizedValue.startsWith('w-') || normalizedValue.includes('woman') || normalizedValue.includes('women') || normalizedValue.includes('mujer') || normalizedValue.includes('female')) {
        return 'w';
      }
      if (normalizedValue === 'm' || normalizedValue.startsWith('m-') || normalizedValue.includes('man') || normalizedValue.includes('men') || normalizedValue.includes('hombre') || normalizedValue.includes('male')) {
        return 'm';
      }
      return '';
    }

    resolveCollectionGender() {
      if (!this.productWrapper) {
        return '';
      }
      let collectionGender = this.normalizeGender(this.productWrapper.dataset.collectionGender);
      if (collectionGender) {
        return collectionGender;
      }
      const resolvedHandle = this.resolveCollectionHandle();
      collectionGender = this.normalizeGender(resolvedHandle);
      if (collectionGender) {
        return collectionGender;
      }
      if (!resolvedHandle) {
        const storedContext = this.getStoredCollectionContext();
        if (storedContext) {
          return this.normalizeGender(storedContext.gender || storedContext.handle);
        }
      }
      return '';
    }

    getStoredCollectionContext() {
      try {
        if (!window.sessionStorage) {
          return null;
        }
        const raw = window.sessionStorage.getItem('theme:collection_context');
        if (!raw) {
          return null;
        }
        const parsed = JSON.parse(raw);
        if (!parsed || !parsed.handle) {
          return null;
        }
        if (this.productWrapper && this.productWrapper.dataset.handle && parsed.productHandle && parsed.productHandle !== this.productWrapper.dataset.handle) {
          return null;
        }
        return parsed;
      } catch (e) {
        return null;
      }
    }

    storeCollectionContext(handle, gender) {
      try {
        if (!window.sessionStorage || !handle) {
          return;
        }
        const productHandle = this.productWrapper ? this.productWrapper.dataset.handle : '';
        const payload = {
          handle: handle,
          gender: gender || '',
          productHandle: productHandle || ''
        };
        window.sessionStorage.setItem('theme:collection_context', JSON.stringify(payload));
      } catch (e) {
        return;
      }
    }

    getCollectionHandleFromReferrer() {
      if (!document.referrer) {
        return '';
      }
      try {
        const referrerUrl = new URL(document.referrer);
        const match = referrerUrl.pathname.match(/\/collections\/([^/]+)/i);
        if (match && match[1]) {
          return decodeURIComponent(match[1]);
        }
      } catch (e) {
        return '';
      }
      return '';
    }

    getRootUrl() {
      if (window.theme && window.theme.routes && typeof window.theme.routes.root_url === 'string') {
        let rootUrl = window.theme.routes.root_url;
        if (rootUrl === '/') {
          return '';
        }
        return rootUrl.replace(/\/$/, '');
      }
      return '';
    }

    buildCollectionProductUrl(collectionHandle) {
      if (!this.productWrapper || !collectionHandle) {
        return '';
      }
      const productHandle = this.productWrapper.dataset.handle;
      if (!productHandle) {
        return '';
      }
      const rootUrl = this.getRootUrl();
      return `${rootUrl}/collections/${collectionHandle}/products/${productHandle}`;
    }

    initCollectionContext() {
      if (!this.productWrapper) {
        return;
      }

      let handle = this.productWrapper.dataset.collectionHandle || '';
      let gender = this.productWrapper.dataset.collectionGender || '';

      if (!handle) {
        handle = this.resolveCollectionHandle();
      }

      if (!handle) {
        handle = this.getCollectionHandleFromReferrer();
      }

      if (!gender && handle) {
        gender = this.normalizeGender(handle);
      }

      if (!handle) {
        const storedContext = this.getStoredCollectionContext();
        if (storedContext) {
          if (storedContext.handle) {
            handle = storedContext.handle;
          }
          if (storedContext.gender) {
            gender = storedContext.gender;
          }
        }
      }

      if (handle) {
        this.productWrapper.dataset.collectionHandle = handle;
      }
      if (gender) {
        this.productWrapper.dataset.collectionGender = gender;
      }

      if (handle) {
        this.storeCollectionContext(handle, gender);
      }

      if (handle && !window.location.pathname.includes('/collections/')) {
        const collectionPath = this.buildCollectionProductUrl(handle);
        if (collectionPath) {
          const currentUrl = new URL(window.location.href);
          const variantId = currentUrl.searchParams.get('variant');
          const nextUrl = variantId ? `${collectionPath}?variant=${variantId}` : collectionPath;
          window.history.replaceState({}, '', nextUrl);
        }
      }
    }

    applyGenderFilter() {
      if (!this.productSlider) {
        return;
      }
      const collectionGender = this.resolveCollectionGender();
      this.collectionGender = collectionGender;

      const mediaMatchesContext = (mediaElement) => {
        const mediaGender = this.normalizeGender(mediaElement.dataset.gender);
        if (!collectionGender) {
          mediaElement.classList.remove('is-gender-hidden');
          mediaElement.removeAttribute('aria-hidden');
          return true;
        }
        const matches = !mediaGender || mediaGender === collectionGender;
        mediaElement.classList.toggle('is-gender-hidden', !matches);
        if (!matches) {
          mediaElement.classList.remove('is-active');
          mediaElement.classList.remove('is-initial-selected');
          mediaElement.setAttribute('aria-hidden', 'true');
        } else {
          mediaElement.removeAttribute('aria-hidden');
        }
        return matches;
      };

      const mediaSlides = Array.from(this.productSlider.querySelectorAll('.product-images__slide, .product-quick-images__slide'));
      let visibleSlides = 0;
      mediaSlides.forEach((mediaElement) => {
        if (mediaMatchesContext(mediaElement)) {
          visibleSlides += 1;
        }
      });

      if (collectionGender && visibleSlides === 0) {
        mediaSlides.forEach((mediaElement) => {
          mediaElement.classList.remove('is-gender-hidden');
          mediaElement.removeAttribute('aria-hidden');
        });
      }

      if (this.thumbnails) {
        const thumbnailItems = Array.from(this.thumbnails.querySelectorAll('.product-thumbnail'));
        let visibleThumbs = 0;
        thumbnailItems.forEach((mediaElement) => {
          if (mediaMatchesContext(mediaElement)) {
            visibleThumbs += 1;
          }
        });
        if (collectionGender && visibleThumbs === 0) {
          thumbnailItems.forEach((mediaElement) => {
            mediaElement.classList.remove('is-gender-hidden');
            mediaElement.removeAttribute('aria-hidden');
          });
        }
      }
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEls = Array.from(this.productSlider.querySelectorAll('[data-set-name]'));
      let dataSetEl = dataSetEls.find((setElement) => {
        return this.querySelector('.product-form__input[data-handle="' + setElement.dataset.setName + '"]');
      });
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        let imageSetField = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]');
        this.imageSetIndex = imageSetField.dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      } else {
        this.applyGenderFilter();
      }
    }

    setImageSetMedia() {
      if (!this.imageSetIndex) {
        this.applyGenderFilter();
        return;
      }
      if (!this.currentVariant) {
        this.applyGenderFilter();
        return;
      }
      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productSlider.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"], .product-quick-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);

      if (this.hideVariants) {
        if (this.thumbnails) {
          // Product images
          this.productWrapper.querySelectorAll('.product-images__slide, .product-quick-images__slide').forEach(thumb => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });
          selected_set_images.forEach(thumb => {
            thumb.classList.toggle('is-active', thumb.dataset.group === group);
          });

          // Product thumbnails
          this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });
          selected_set_thumbs.forEach(thumb => {
            thumb.classList.toggle('is-active', thumb.dataset.group === group);
          });
        } else {
          // Product images
          this.productWrapper.querySelectorAll('.product-images__slide, .product-quick-images__slide').forEach(thumb => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });
          selected_set_images.forEach(thumb => {
            if (thumb.dataset.group === group) {
              thumb.classList.add('is-active');
            }
          });
        }

      } else {

        if (!this.thumbnails) {
          let set_images = Array.from(selected_set_images).filter(function (element) {
            return element.dataset.group === group;
          });
          set_images.forEach(thumb => {
            thumb.parentElement.prepend(thumb);
          });
        }

      }
      this.applyGenderFilter();
      if (!this.thumbnails) {
        setTimeout(() => {
          let paginationSlider = this.productSlider.querySelector('product-slider');
          if (paginationSlider) {
            paginationSlider.onPaginationResize();
          }
        }, 100);
      }
    }

    createAvailableOptionsTree(variants, currentlySelectedValues) {
      // Reduce variant array into option availability tree
      return variants.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = { value: variant[index], isUnavailable: true };
            options[index].push(entry);
          }

          const currentOption1 = currentlySelectedValues.find(({ value, index }) => index === 'option1');
          const currentOption2 = currentlySelectedValues.find(({ value, index }) => index === 'option2');

          switch (index) {
            case 'option1':
              // Option1 inputs should always remain enabled based on all available variants
              entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              break;
            case 'option2':
              // Option2 inputs should remain enabled based on available variants that match first option group
              if (currentOption1 && variant.option1 === currentOption1.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
              break;
            case 'option3':
              // Option 3 inputs should remain enabled based on available variants that match first and second option group
              if (currentOption1 && variant.option1 === currentOption1.value && currentOption2 && variant.option2 === currentOption2.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
          }
        });

        return options;
      }, { option1: [], option2: [], option3: [] });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.pagination = this.parentElement.querySelector('.product-images-buttons');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      // Start Gallery
      let observer = new MutationObserver(() => {
        this.setupProductGallery();
      });

      observer.observe(this, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        characterData: false
      });

      this.setupProductGallery();

      // Start Pagination
      if (this.pagination) {
        this.setupPagination();
        this.resizeObserver = new ResizeObserver(entries => this.onPaginationResize());
        this.resizeObserver.observe(this);
        this.addEventListener('scroll', this.updatePagination.bind(this));
      }
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }

      this.setEventListeners();
    }
    buildItems(activeImages) {
      let images = activeImages.map((item) => {
        let activelink = item.querySelector('.product-single__media-zoom');
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          title: activelink.getAttribute('title')
        };
      });
      return images;
    }
    setEventListeners() {
      let activeImages = Array.from(this.querySelectorAll('.product-images__slide--image')).filter(element => element.clientWidth > 0),
        items = this.buildItems(activeImages),
        captionEl = this.dataset.captions,
        pswpElement = document.querySelectorAll('.pswp')[0],
        options = {
          maxSpreadZoom: 2,
          loop: false,
          allowPanToNext: false,
          closeOnScroll: false,
          showHideOpacity: false,
          arrowKeys: true,
          history: false,
          captionEl: captionEl,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: true,
          arrowEl: true,
          preloaderEl: true
        };

      let openPswp = function (e, link, options, pswpElement, items) {
        let parent = link.closest('.product-images__slide');
        let i = activeImages.indexOf(parent);
        options.index = parseInt(i, 10);
        options.getThumbBoundsFn = () => {
          const thumbnail = link.closest('.product-single__media'),
            pageYScroll = window.scrollY || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        };
        if (typeof PhotoSwipe !== 'undefined') {
          let pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

          pswp.listen('firstUpdate', () => {
            pswp.listen('parseVerticalMargin', function (item) {
              item.vGap = {
                top: 50,
                bottom: 50
              };
            });
          });
          pswp.init();
        }
        e.preventDefault();
      };
      this.querySelectorAll('.product-single__media-zoom').forEach(function (link) {
        let thumbnail = link.closest('.product-single__media');
        let clone = link.cloneNode(true);
        thumbnail.append(clone);
        link.remove();
        clone.addEventListener('click', (e) => openPswp(e, clone, options, pswpElement, items));
      });

      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
    }
    setupPagination() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

      this.currentPageElement = this.pagination.querySelector('.slider-counter--current');
      this.pageTotalElement = this.pagination.querySelector('.slider-counter--total');

      this.prevButton = this.pagination.querySelector('button[name="previous"]');
      this.nextButton = this.pagination.querySelector('button[name="next"]');


      this.prevButton.addEventListener('click', this.onPaginationButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onPaginationButtonClick.bind(this));

      this.updatePagination();
    }
    onPaginationResize() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);

      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.updatePagination();
    }
    onPaginationButtonClick(event) {
      event.preventDefault();
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.scrollLeft + (1 * this.sliderItemOffset) : this.scrollLeft - (1 * this.sliderItemOffset);
      this.scrollTo({
        left: this.slideScrollPosition
      });
    }
    updatePagination() {
      if (!this.nextButton) return;

      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPageElement) {
        this.currentPageElement.textContent = this.currentPage;
      }
      if (this.pageTotalElement) {
        this.pageTotalElement.textContent = this.sliderItemsToShow.length;
      }

      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        }));
      }

      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.scrollLeft;
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.onSubmitHandlerBound = this.onSubmitHandler.bind(this);
      this.onStickySubmitBound = this.onStickySubmit.bind(this);
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      if (!this.form) {
        return;
      }
      this.form.querySelector('[name=id]').disabled = false;
      this.stickySubmitButton = this.querySelector('[data-sticky-submit]');
      if (this.sticky) {
        this.stickySubmitButton?.addEventListener('click', this.onStickySubmitBound);
      } else {
        this.form.addEventListener('submit', this.onSubmitHandlerBound);
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    syncCartState() {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
    }
    disconnectedCallback() {
      if (!this.form) {
        return;
      }

      if (this.sticky) {
        this.stickySubmitButton?.removeEventListener('click', this.onStickySubmitBound);
      } else {
        this.form.removeEventListener('submit', this.onSubmitHandlerBound);
      }
    }
    onStickySubmit(evt) {
      evt.preventDefault();
      if (!this.form) {
        return;
      }
      if (typeof this.form.requestSubmit === 'function') {
        this.form.requestSubmit();
        return;
      }

      const submitButton = this.form.querySelector('[type="submit"][name="add"]');
      if (submitButton) {
        submitButton.click();
        return;
      }

      this.form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.form.reportValidity()) {
        return;
      }
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            if (response.status === 422) {
              this.syncCartState();
            }
            this.handleErrorMessage(response.description);
            return;
          }

          try {
            this.renderContents(response);
          } catch (error) {
            console.error(error);
            this.syncCartState();

            if (document.getElementById('Cart-Drawer')) {
              document.body.classList.add('open-cc');
              document.body.classList.add('open-cart');
              document.getElementById('Cart-Drawer').classList.add('active');
              dispatchCustomEvent('cart-drawer:open');
            }
          }

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
          window.requestAnimationFrame(() => {
            this.syncCartState();
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        if (!parsedState.sections || !parsedState.sections[section.section]) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        const sectionMarkup = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof sectionMarkup !== 'string') {
          return;
        }

        elementToReplace.innerHTML = sectionMarkup;

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.notesToggle();
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }
        if (section.id === 'Cart' && typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));



      let product_drawer = document.getElementById('Product-Drawer');
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.querySelector('.product-quick-images--container')?.classList.remove('active');
        document.body.classList.remove('open-quick-view');

        if (window.innerWidth < 1069) {
          product_drawer.classList.remove('active');
          if (document.getElementById('Cart-Drawer')) {
            document.getElementById('Cart-Drawer').classList.add('active');
            document.body.classList.add('open-cart');
            document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')?.classList.add('active');
            dispatchCustomEvent('cart-drawer:open');
          }
        } else {
          product_drawer.querySelector('.product-quick-images--container')?.addEventListener('transitionend', function () {
            product_drawer.classList.remove('active');

            if (document.getElementById('Cart-Drawer')) {
              document.getElementById('Cart-Drawer').classList.add('active');
              document.body.classList.add('open-cart');
              document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')?.classList.add('active');
              dispatchCustomEvent('cart-drawer:open');
            }
          });
        }

        if (!document.getElementById('Cart-Drawer')) {
          document.body.classList.remove('open-cc');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
      return parsedDocument.querySelector(selector)?.innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

if (!customElements.get('product-back-in-stock-form')) {
  customElements.define('product-back-in-stock-form', class ProductBackInStockForm extends HTMLElement {
    constructor() {
      super();
      this.onToggle = this.onToggle.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onInputKeydown = this.onInputKeydown.bind(this);
    }
    connectedCallback() {
      this.toggleButton = this.querySelector('[data-bis-toggle]');
      this.form = this.querySelector('[data-bis-form]');
      this.input = this.querySelector('[data-bis-input]');
      this.submitButton = this.querySelector('[data-bis-submit]');
      this.message = this.querySelector('[data-bis-message]');
      this.defaultSubmitLabel = this.submitButton ? this.submitButton.textContent.trim() : '';

      this.toggleButton?.addEventListener('click', this.onToggle);
      this.submitButton?.addEventListener('click', this.onSubmit);
      this.input?.addEventListener('keydown', this.onInputKeydown);
    }
    disconnectedCallback() {
      this.toggleButton?.removeEventListener('click', this.onToggle);
      this.submitButton?.removeEventListener('click', this.onSubmit);
      this.input?.removeEventListener('keydown', this.onInputKeydown);
    }
    getCompanyId() {
      const klaviyoScript = Array.from(document.scripts).find((script) => script.src && script.src.includes('static.klaviyo.com/onsite/js/'));

      if (!klaviyoScript || !klaviyoScript.src) {
        return '';
      }

      try {
        const url = new URL(klaviyoScript.src);
        return url.searchParams.get('company_id') || url.pathname.split('/').filter(Boolean)[2] || '';
      } catch (e) {
        return '';
      }
    }
    decodeHtmlEntities(value) {
      if (!value || !value.includes('&')) {
        return value || '';
      }

      const textarea = document.createElement('textarea');
      textarea.innerHTML = value;
      return textarea.value;
    }
    setLoading(isLoading) {
      if (!this.submitButton || !this.input) {
        return;
      }

      const formIsOpen = this.form && this.form.hidden === false;

      this.submitButton.disabled = isLoading ? true : !formIsOpen;
      this.input.disabled = isLoading ? true : !formIsOpen;
      this.submitButton.textContent = isLoading ? '...' : this.defaultSubmitLabel;
    }
    showMessage(text, type) {
      if (!this.message) {
        return;
      }

      this.message.textContent = text || '';
      this.message.hidden = !text;
      this.message.classList.toggle('is-success', type === 'success');
      this.message.classList.toggle('is-error', type === 'error');
    }
    clearProductFormError() {
      const productForm = this.closest('product-form');

      if (productForm && typeof productForm.handleErrorMessage === 'function') {
        productForm.handleErrorMessage();
      }
    }
    resetForm() {
      this.classList.remove('is-active');
      if (this.form) {
        this.form.hidden = true;
        this.form.style.display = 'none';
      }
      if (this.toggleButton) {
        this.toggleButton.hidden = false;
        this.toggleButton.disabled = false;
        this.toggleButton.style.display = '';
        this.toggleButton.setAttribute('aria-expanded', 'false');
      }
      if (this.input) {
        this.input.value = '';
        this.input.disabled = true;
      }
      if (this.submitButton) {
        this.submitButton.disabled = true;
        this.submitButton.textContent = this.defaultSubmitLabel;
      }
      this.clearProductFormError();
      this.showMessage('', '');
    }
    updateState(state = {}) {
      if (typeof state.available !== 'undefined') {
        this.hidden = !state.available;
      }
      if (typeof state.variantId !== 'undefined') {
        this.dataset.variantId = state.variantId || '';
      }
      if (typeof state.klaviyoVariantId !== 'undefined') {
        this.dataset.klaviyoVariantId = state.klaviyoVariantId || '';
      }
      this.resetForm();
    }
    onToggle(event) {
      event.preventDefault();
      if (!this.form || !this.toggleButton) {
        return;
      }

      this.classList.add('is-active');
      this.toggleButton.hidden = true;
      this.toggleButton.style.display = 'none';
      this.toggleButton.setAttribute('aria-expanded', 'true');
      this.form.hidden = false;
      this.form.style.display = 'block';
      if (this.input) {
        this.input.disabled = false;
      }
      if (this.submitButton) {
        this.submitButton.disabled = false;
      }
      this.clearProductFormError();
      this.showMessage('', '');

      window.requestAnimationFrame(() => {
        this.input?.focus();
      });
    }
    onInputKeydown(event) {
      if (event.key !== 'Enter') {
        return;
      }

      event.preventDefault();
      this.onSubmit();
    }
    onSubmit(event) {
      event?.preventDefault?.();

      if (!this.input || !this.submitButton) {
        return;
      }

      const email = this.input.value.trim();
      const invalidEmailMessage = this.decodeHtmlEntities(this.dataset.invalidEmailMessage) || 'Please enter a valid email address.';
      const genericErrorMessage = this.decodeHtmlEntities(this.dataset.errorMessage) || 'Something went wrong. Please try again.';
      const successMessage = this.decodeHtmlEntities(this.dataset.successMessage) || "You're in! We'll let you know when it's back.";
      const variantId = this.dataset.klaviyoVariantId;
      const companyId = this.getCompanyId();

      if (!email || !this.input.checkValidity()) {
        this.showMessage(invalidEmailMessage, 'error');
        this.input.focus();
        return;
      }

      if (!variantId || !companyId) {
        this.clearProductFormError();
        this.showMessage(genericErrorMessage, 'error');
        return;
      }

      this.setLoading(true);
      this.clearProductFormError();
      this.showMessage('', '');

      const payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                }
              }
            },
            channels: ['EMAIL']
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: variantId
              }
            }
          }
        }
      };

      fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(companyId)}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: '2024-06-15'
        },
        body: JSON.stringify(payload)
      })
        .then(async (response) => {
          if (response.status === 202) {
            this.setLoading(false);
            this.resetForm();
            if (this.toggleButton) {
              this.toggleButton.disabled = true;
            }
            this.showMessage(successMessage, 'success');
            return;
          }

          let errorMessage = genericErrorMessage;

          try {
            const errorResponse = await response.json();
            const firstError = errorResponse?.errors?.[0];
            if (firstError?.detail && firstError.detail.toLowerCase().includes('email')) {
              errorMessage = invalidEmailMessage;
            } else if (firstError?.detail) {
              errorMessage = firstError.detail;
            }
          } catch (e) {
            errorMessage = genericErrorMessage;
          }

          throw new Error(errorMessage);
        })
        .catch((error) => {
          this.showMessage(error.message || genericErrorMessage, 'error');
        })
        .finally(() => {
          this.setLoading(false);
        });
    }
  });
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
      this.handleScroll = this.handleScroll.bind(this);
      this.updateVisibility = this.updateVisibility.bind(this);
    }
    connectedCallback() {
      this.trigger = document.querySelector(`#ProductInfo-${this.dataset.section} #AddToCart`) || document.getElementById('AddToCart');
      this.footer = document.getElementById('footer');

      if (!this.trigger) return;

      window.addEventListener('scroll', this.handleScroll, {
        passive: true
      });
      window.addEventListener('resize', this.handleScroll);
      this.updateVisibility();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleScroll);
    }
    handleScroll() {
      if (this.frameRequested) return;

      this.frameRequested = true;
      window.requestAnimationFrame(() => {
        this.updateVisibility();
        this.frameRequested = false;
      });
    }
    updateVisibility() {
      if (!this.trigger) return;

      const triggerRect = this.trigger.getBoundingClientRect();
      const passedTrigger = triggerRect.bottom <= 0;
      const footerVisible = this.footer ? this.footer.getBoundingClientRect().top <= window.innerHeight : false;

      this.classList.toggle('sticky--visible', passedTrigger && !footerVisible);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}
